import { type SVGProps } from 'react'
const Typedream = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 834 512'
        {...props}
    >
        <path
            fill='#8000ff'
            fillRule='evenodd'
            d='M704.999 256c0-141.385-114.615-256-256-256s-256 114.615-256 256 114.615 256 256 256 256-114.615 256-256z'
            clipRule='evenodd'
        />
        <path
            fill='#00c0ff'
            d='M704.999 256v-.093h.153c70.692 0 128 57.307 128 128 0 70.692-57.308 128-128 128h-.153V512h-251v-.048c55.77-1.068 107.174-19.971 148.746-51.243C658.836 418.515 697.027 353.803 703.889 280a259.068 259.068 0 0 0 1.11-24z'
        />
        <path
            fill='#ff0060'
            fillRule='evenodd'
            d='M191.998 511.999C85.96 511.999 0 426.038 0 319.999c0-106.038 85.96-192 191.998-192 105.857 0 191.705 85.668 191.999 191.457h.001V449.001c.002 54.302 66.001 62.998 66.001 62.998H192.544v-.001l-.546.001z'
            clipRule='evenodd'
        />
        <path
            fill='#6000c0'
            d='M323.447 32.584c-.509-.213-56.447 26.45-98.517 98.229 90.175 15.587 158.804 94.076 159.067 188.643h.001v129.545c.002 46.675 48.764 59.656 62.461 62.381h7.119s-18.998-22.237-13.701-62.381c5.298-40.145 21.39-159.798 21.39-159.798h-.003C475.552 180.181 419.636 72.84 323.447 32.584z'
        />
    </svg>
)
export default Typedream
